var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0214 20.8333H1.89394V0.946971C1.89394 0.423925 1.47002 0 0.946971 0C0.423925 0 0 0.423925 0 0.946971V21.7803C0 22.3033 0.423925 22.7273 0.946971 22.7273H24.0214C24.5445 22.7273 24.9684 22.3033 24.9684 21.7803C24.9684 21.2572 24.5445 20.8333 24.0214 20.8333ZM21.7922 4.38753H16.9508C16.4277 4.38753 16.0038 3.96361 16.0038 3.44056C16.0038 2.91752 16.4277 2.49359 16.9508 2.49359H24.053C24.5761 2.49359 25 2.91752 25 3.44056V3.46225C25 3.46885 25 3.47546 25 3.48206V10.5428C25 11.0658 24.5761 11.4901 24.0531 11.4901C23.53 11.4901 23.1061 11.0658 23.1061 10.5431V5.75194L16.8614 11.9715C16.4909 12.3399 15.8933 12.3396 15.5237 11.9699L13.447 9.89357L5.68845 17.6518C5.50383 17.8367 5.26106 17.9292 5.01897 17.9292C4.77654 17.9292 4.53411 17.8367 4.34944 17.6518C3.97947 17.2821 3.97947 16.6824 4.34944 16.3127L12.7775 7.88469C13.1474 7.51472 13.7465 7.51506 14.1165 7.88469L16.1944 9.96266L21.7922 4.38753Z",
    fill: "#00C8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.42e614c643f2a71a5ca68abbb2815370.svg";
export { ForwardRef as ReactComponent };